import type { StaticLayerPayload } from "@config";
import { TextLibrary } from "@library-elements/text";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: TextLibrary,
};

export const RichText = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
